import styled from "styled-components";
import * as Color from "../Color";

/** The handle */
export const Handle = styled.button.attrs({ type: "button" })`
  background-color: transparent;
  border: none;
  padding: 0.5rem;
  border-radius: 0.25rem;
  cursor: grab;
  transition: all linear 200ms;
  width: 22px;
  height: 26px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  touch-action: none;

  &:hover,
  &.active {
    background-color: ${Color.toString(Color.Turqoise[50])};
  }
`;
